
import React from "react";

export default function PublicChatbotDemo() {
    // CRA environment variables can override the default slug.
    const demoSlug =
        process.env.REACT_APP_DEMO_RESTAURANT_SLUG ||
        (process.env.NODE_ENV === "production" ? "demo" : "admin");

    const demoUrl =
        `/chatbot-ui/${encodeURIComponent(demoSlug)}?layout=compact`;

    return (
        <section
            id="live-demo"
            className="scroll-mt-20 bg-gradient-to-b from-white to-blue-50 py-20 lg:py-24"
        >
            <div className="container mx-auto px-4">

                {/* Section heading */}
                <div className="mx-auto mb-12 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full bg-indigo-50 px-4 py-2 text-sm font-semibold text-indigo-700">
            Interactive Product Demo
          </span>

                    <h2 className="mt-5 text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        Experience SavoryBot Yourself
                    </h2>

                    <p className="mt-4 text-lg leading-relaxed text-gray-600">
                        See how your customers can discover dishes,
                        explore your menu, and receive personalized
                        food recommendations in seconds.
                    </p>
                </div>

                <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-2 lg:gap-16">

                    {/* Product explanation */}
                    <div>
                        <h3 className="text-2xl font-bold text-gray-900 sm:text-3xl">
                            Imagine This on Your Restaurant Website
                        </h3>

                        <p className="mt-5 leading-relaxed text-gray-600">
                            Your customers no longer have to scroll through
                            a long menu trying to decide what to eat.
                            SavoryBot helps them explore dishes that match
                            their preferences, cravings, and budget.
                        </p>

                        <div className="mt-8 space-y-5">
                            {[
                                {
                                    number: "01",
                                    title: "Tell SavoryBot What You Like",
                                    description:
                                        "Enter a craving, meal time, and budget.",
                                },
                                {
                                    number: "02",
                                    title: "Get Personalized Suggestions",
                                    description:
                                        "Explore recommendations from a sample restaurant menu.",
                                },
                                {
                                    number: "03",
                                    title: "Discover Your Next Meal",
                                    description:
                                        "View dish descriptions, images, and prices.",
                                },
                            ].map((item) => (
                                <div key={item.number} className="flex gap-4">
                                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-100 font-bold text-indigo-700">
                                        {item.number}
                                    </div>

                                    <div>
                                        <h4 className="font-semibold text-gray-900">
                                            {item.title}
                                        </h4>

                                        <p className="mt-1 text-sm leading-relaxed text-gray-600">
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <a
                            href="/login"
                            className="mt-9 inline-flex items-center justify-center rounded-full bg-indigo-600 px-7 py-3 font-semibold text-white shadow-md transition hover:bg-indigo-700"
                        >
                            Start Your 14-Day Free Trial
                        </a>
                    </div>

                    {/* Live chatbot */}
                    <div className="mx-auto w-full max-w-[460px]">
                        <div className="overflow-hidden rounded-3xl border border-gray-200 bg-white shadow-2xl">

                            <div className="flex items-center gap-3 border-b border-gray-100 bg-white px-5 py-4">
                                <span className="h-3 w-3 rounded-full bg-green-500" />

                                <div>
                                    <p className="font-semibold text-gray-900">
                                        SavoryBot Interactive Demo
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        Sample restaurant menu
                                    </p>
                                </div>
                            </div>

                            <iframe
                                src={demoUrl}
                                title="SavoryBot Live Restaurant Demo"
                                className="block h-[620px] w-full border-0 sm:h-[680px]"
                                loading="lazy"
                            />
                        </div>

                        <p className="mt-4 text-center text-xs text-gray-500">
                            This demo uses sample menu data.
                            Please confirm food allergies and ingredients
                            directly with the restaurant.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
